module.exports = __webpack_public_path__ + "img/sarajklima.1e5c5cd8.png";